import React, { useEffect, useRef, useState, useCallback } from 'react'
import { Box } from '@mui/joy';
import { Background, Controls, ReactFlow } from '@xyflow/react';
import { useSettingContextInComponent, useSettingsContext } from 'src/mtska-frontend-app-scaffolding'
import '@xyflow/react/dist/style.css';
import { useReactFlowData } from './flow.hooks';
import JSONPretty from 'react-json-pretty'


const Flow = (props) => {
    const {
        items,
        onConnectStart,
        onNodeDoubleClick,
        onFilterPageSortChange: onGetFreshData = () => { },
        dataProviderName,
        filters: defaultFilters = { items: [] },
        nodeElementType,
        loading
    } = props;

    const { settings, addKeyToFilterModel } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localFilterModel, setLocalFilterModel] = useState();
    const previousLocalFilterModelRef = useRef();

    const [isInitialized, setIsInitialized] = useState(false);

    const { nodes, edges } = useReactFlowData(items, nodeElementType, props.childrenNodeKey);

    // -------------
    // GESTIONE DEL CAMBIO DI STATI
    // -------------
    useEffect(() => {
        if (JSON.stringify(previousLocalFilterModelRef.current) !== JSON.stringify(localFilterModel)) {
            previousLocalFilterModelRef.current = localFilterModel;

            const filterPageSort = { ...settings }
            onGetFreshData(filterPageSort);
        }

        if (!isInitialized && localFilterModel) {
            setIsInitialized(true);
        }
    }, [localFilterModel]);

    useEffect(() => {
        if (!filterModel) return;
        //console.info('-5--OTTENGO COME RISULTATO IL CORTESE',filterModel, "A PARTIRE DAGLI ESIMI",dataProviderName, defaultFilters)
        setLocalFilterModel(addKeyToFilterModel(filterModel));
    }, [filterModel]);

    return (
        <Box className="flow-wrapper">
            <ReactFlow
                nodes={nodes}
                edges={edges}
                onNodeDoubleClick={(event, node) => {
                    onNodeDoubleClick(node, event)
                }}

                onConnectStart={(event, nodeData) => {
                    if (event.target.className.includes('react-flow__handle-top')) return;
                    const node = nodes.find(n => n.id === nodeData.nodeId);
                    onConnectStart(node)
                }}
                fitView
                zoomOnScroll={false}
                colorMode={'light'}
            >
                <Controls />
                <Background variant="dots" gap={12} size={1} />
            </ReactFlow>
        </Box>
    )
}

export default Flow